module.exports = __webpack_public_path__ + "img/accessory_hat_02.f719b510.svg";